import React, { useState } from 'react';
import './FeedbackModal.css';
import apiClient from '../services/apiClient';
import toast from 'react-hot-toast';

const FeedbackModal = ({ isOpen, onClose }) => {
    const [rating, setRating] = useState(0);
    const [hoverRating, setHoverRating] = useState(0);
    const [feedback, setFeedback] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (!isOpen) return null;

    const handleSubmit = async () => {
        if (rating === 0) {
            toast.error('Please select a rating');
            return;
        }

        setSubmitting(true);
        try {
            await apiClient.submitFeedback(rating, feedback);
            toast.success('Thank you for your feedback! 🎉');
            onClose();
            // Reset form
            setRating(0);
            setFeedback('');
        } catch (error) {
            toast.error('Failed to submit feedback. Please try again.');
        } finally {
            setSubmitting(false);
        }
    };

    const handleClose = () => {
        setRating(0);
        setFeedback('');
        onClose();
    };

    return (
        <div className="feedback-modal-overlay" onClick={handleClose}>
            <div className="feedback-modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="feedback-modal-close" onClick={handleClose}>×</button>

                <div className="feedback-modal-body">
                    <h2>Share Your Feedback</h2>
                    <p>Help us improve SystemCraft</p>

                    <div className="rating-section">
                        <label>Rate your experience</label>
                        <div className="stars">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <button
                                    key={star}
                                    className={`star ${star <= (hoverRating || rating) ? 'filled' : ''}`}
                                    onClick={() => setRating(star)}
                                    onMouseEnter={() => setHoverRating(star)}
                                    onMouseLeave={() => setHoverRating(0)}
                                >
                                    ★
                                </button>
                            ))}
                        </div>
                        {rating > 0 && (
                            <span className="rating-text">
                                {rating === 5 && 'Excellent! ⭐'}
                                {rating === 4 && 'Great! 😊'}
                                {rating === 3 && 'Good 👍'}
                                {rating === 2 && 'Okay 😐'}
                                {rating === 1 && 'Needs improvement 😔'}
                            </span>
                        )}
                    </div>

                    <div className="feedback-text-section">
                        <label>Share your thoughts (optional)</label>
                        <textarea
                            className="feedback-textarea"
                            placeholder="Tell us what you liked, what could be improved, or suggest new features..."
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                            rows={4}
                            maxLength={1000}
                        />
                        <div className="char-count">{feedback.length}/1000</div>
                    </div>

                    <div className="feedback-actions">
                        <button
                            className="btn-cancel"
                            onClick={handleClose}
                            disabled={submitting}
                        >
                            Cancel
                        </button>
                        <button
                            className="btn-submit"
                            onClick={handleSubmit}
                            disabled={submitting || rating === 0}
                        >
                            {submitting ? 'Submitting...' : 'Submit Feedback'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FeedbackModal;
